import { t } from '@avalara/bat-apps-shared/i18n';
import { Fragment } from 'react';
import FormInput from '../../../containers/shared/forms/form-input';
import { FlexContainerRowInner } from '../../styled/skylab/page';

export const startFormFields = () => (
  <Fragment>
    <FlexContainerRowInner>
      <fieldset>
        <label htmlFor='firstName'>{t('client.placeholders.first-name')}</label>
        <FormInput fieldName='firstName' />
      </fieldset>
      <fieldset>
        <label htmlFor='lastName'>{t('client.placeholders.last-name')}</label>
        <FormInput fieldName='lastName' />
      </fieldset>
    </FlexContainerRowInner>
    <fieldset>
      <label htmlFor='email'>{t('client.labels.email-username')}</label>
      <FormInput type='email' fieldName='email' validateDuringInput={true} />
    </fieldset>
    <fieldset>
      <label htmlFor='phone'>{t('client.labels.phone')}</label>
      <FormInput type='tel' fieldName='phone' maxLength={15} validateDuringInput={true} />
    </fieldset>
  </Fragment>
);

export default startFormFields;
